import jwtDecode from 'jwt-decode';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {authActions} from '../Containers/Auth/store';
import {settingsActions} from '../Containers/Settings/store';
import {getActiveSalonToken, setActiveSalonById} from "./salonToken";
import {getActiveSalonId} from "../Containers/Auth/store/selectors";
import { markSalonsListMigrationComplete, needsSalonsListReLogin } from './businessToken';
import { clearSessionStoragePreservingFromApp } from './clearSessionStorage';

function useAuth() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const activeSalonId = useSelector(getActiveSalonId());

  useEffect(() => {
    try {
      const activeSalonToken = getActiveSalonToken();
      if (!activeSalonToken) {
        setIsLoading(false);
        dispatch(authActions.LOG_OUT.SUCCESS());
        return;
      }

      const activeSalonDecode = jwtDecode(activeSalonToken);
      const salons = JSON.parse(localStorage.getItem('salons')) || [];
      const activeSalons = salons.filter(
        (salon) => salon.eliminato == null || +salon.eliminato === 0,
      );
      const now = Date.now();
      const isExpired = activeSalonDecode.exp * 1000 < now;

      if (isExpired) {
        clearSessionStoragePreservingFromApp();
        dispatch(authActions.LOG_OUT.SUCCESS());
        setIsLoading(false);
        return;
      }

      if (needsSalonsListReLogin(activeSalons)) {
        clearSessionStoragePreservingFromApp();
        dispatch(authActions.LOG_OUT.SUCCESS());
        dispatch(settingsActions.SHOW_TOKEN_EXPIRED_MODAL.SUCCESS({ reason: 'salonsList' }));
        setIsLoading(false);
        return;
      }

      if (activeSalons.length > 1) {
        markSalonsListMigrationComplete();
      }

      dispatch(
        authActions.SIGN_IN.SUCCESS({
          activeSalonId: +activeSalonDecode.idSalone,
          salons: activeSalons,
        }),
      );
      setIsLoading(false);
    } catch {
      clearSessionStoragePreservingFromApp();
      dispatch(authActions.LOG_OUT.SUCCESS());
      setIsLoading(false);
    }
  }, [dispatch, activeSalonId]);

  return {isLoading};
}

export default useAuth;
